import { BaseModel } from "@/models/base.model"
import { type ISurchargePeriod } from "@/interfaces/api/surcharge-period.interface"
import { type Moment } from "moment"

export abstract class SurchargePeriod extends BaseModel implements ISurchargePeriod {
  periodStart: Moment
  periodEnd: Moment
  surchargePercent: string | undefined
  surchargeFlat: string | undefined
  surchargePerUnit: string | undefined

  protected constructor(surchargePeriod: ISurchargePeriod) {
    super(surchargePeriod)

    this.periodStart = surchargePeriod.periodStart
    this.periodEnd = surchargePeriod.periodEnd
    this.surchargePercent = surchargePeriod.surchargePercent
    this.surchargePerUnit = surchargePeriod.surchargePerUnit
    this.surchargeFlat = surchargePeriod.surchargeFlat
  }
}
